import {
  Module, VuexModule, Mutation, Action,
} from 'vuex-module-decorators';

export type RightBarState = {
  open: boolean,
  componentLeft?: any,
  componentRight?: any,
}

@Module({ name: 'UiModule' })
export default class UiModule extends VuexModule {
  leftBar: {open: boolean} = { open: false }

  rightBar: RightBarState = {
    open: false,
    componentLeft: null,
    componentRight: null,
  }

  get leftBarState() {
    return this.leftBar;
  }

  get rightBarState() {
    return this.rightBar;
  }

  @Mutation
  SET_LEFTBAR_STATE(open: boolean) {
    this.leftBar.open = open;
  }

  @Mutation
  SET_RIGHTBAR_STATE(state: RightBarState) {
    this.rightBar = state;
  }

  @Action({ rawError: true })
  toggleLeftBar(): void {
    this.context.commit('SET_LEFTBAR_STATE', !this.leftBar.open);
  }

  @Action({ rawError: true })
  openRightBar({ componentLeft, componentRight }: { componentLeft: any, componentRight?: any }) {
    const newState: RightBarState = {
      open: true,
      componentLeft,
      componentRight,
    };
    this.context.commit('SET_RIGHTBAR_STATE', newState);
  }

  @Action({ rawError: true })
  closeRightBar() {
    const newState: RightBarState = {
      open: false,
      componentLeft: null,
      componentRight: null,
    };
    this.context.commit('SET_RIGHTBAR_STATE', newState);
  }
}
